export const DATA_CONFIRM = 'data-confirm';

const createAttribute = (attribute: string): string =>
  `${DATA_CONFIRM}-${attribute}`;

export const DATA_CANCEL_LABEL = createAttribute('cancel-label');
export const DATA_CONFIRM_LABEL = createAttribute('confirm-label');
export const DATA_NO_DELETE = createAttribute('no-delete');
export const DATA_TEXT = createAttribute('text');
export const DATA_TITLE = createAttribute('title');
export const MODAL_ID = '__confirm-modal';
export const ROOT_ID = '__confirm-root';
